/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdServerConfig} from "../config/api-config";

const SCRIPT_LINK = "\x3Cscript src=\"https://cdn.adnuntius.com/adn.js\" async>\x3C/script>\n" +
  "\x3Cscript>\nwindow.adn = window.adn || {}; adn.calls = adn.calls || []; adn.calls.push(function() { \n  adn.regConversion({\n    eventType: 'customEventIdReplace', \n    network: 'networkIdIdReplace', \n    adSource: 'lineItemIdReplace'\n  });\n});\n\x3C/script>";
const CPA_LINK = "<img src=\"" + AdServerConfig.obtain().getUri("pixelc.gif") +
  "?eventType=customEventIdReplace&network=networkIdIdReplace&adSource=lineItemIdReplace\">";

export class CpaDefaults {

  static getLink(customEventId, tagId, modelId): string {
    let link: string;
    if (customEventId) {
      link = CPA_LINK.replace("customEventIdReplace", customEventId);
    } else {
      link = CPA_LINK.replace("eventType=customEventIdReplace&", "");
    }
    return link
      .replace("networkIdIdReplace", (tagId || "unspecified"))
      .replace("lineItemIdReplace", (modelId || "unspecified"));
  }

  static getScript(customEventId, tagId, modelId): string {
    let link: string;
    if (customEventId) {
      link = SCRIPT_LINK.replace("customEventIdReplace", customEventId);
    } else {
      link = SCRIPT_LINK.replace("\n    eventType: 'customEventIdReplace', ", "");
    }
    return link
      .replace("networkIdIdReplace", (tagId || "unspecified"))
      .replace("lineItemIdReplace", (modelId || "unspecified"));
  }
}
